import { useState } from "react";

const FAQS = [
  {
    q: "投稿被打回还能重新提交吗？",
    a: "可以。被打回的投稿不会消失，我们会给出具体的修改建议，你按意见调整（比如补全关键信息、修正格式或重新打码）后，可再次提交，且不重复记录不良记录。",
  },
  {
    q: "搬运别人的瓜算不算抄袭？",
    a: "算。直接照搬文字或改写他人发布的瓜料再投稿属于搬运与洗稿，违反原创规定，一经查实会取消投稿资格并封禁账号。请只投你亲自见证或掌握一手资料的瓜料。",
  },
  {
    q: "配图里出现他人照片该怎么办？",
    a: "涉及真实人物的照片请先取得授权，无法授权时必须对头像、电话、住址、证件号等敏感信息打码处理，只保留能佐证事件的关键画面即可。",
  },
  {
    q: "投稿有稿酬吗，怎么结算？",
    a: "过审并获推荐展示的优质瓜料按规则结算稿酬，根据阅读量与质量综合评定。结算会在审核通过并发布后的约定周期内通过你提交的联系方式联系你完成。",
  },
  {
    q: "想匿名投稿可以吗？",
    a: "完全可以。你可以在署名栏填写昵称或选择匿名，你的身份与联系方式仅用于审核和稿酬结算，不会公开展示或泄露给第三方。",
  },
  {
    q: "多少字算合适，太短会被打回吗？",
    a: "正文建议 300–800 字为佳，信息完整的前提下越精炼越好。能一句话说清的小瓜即使不到 300 字也会正常审核，核心是「讲得清楚」，而不是字数本身。",
  },
];

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/60 py-16 md:py-24">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(FAQ_SCHEMA) }}
      />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-medium text-secondary-800">
            <i className="ri-questionnaire-line"></i> 投稿常见问题
          </span>
          <h2 className="mt-4 font-display text-3xl text-foreground-900 md:text-4xl">
            关于投稿，你可能还想问
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-foreground-700">
            下面是吃瓜群众问得最多的问题。如果还没解答你的疑惑，欢迎在投稿时留言，或通过下方联系方式告诉我们。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {FAQS.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <h3 className="flex items-center gap-3 font-bold text-foreground-900">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-sm font-bold text-secondary-700">
                      Q
                    </span>
                    <span className="text-[15px] md:text-base">{item.q}</span>
                  </h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 md:px-6">
                    <div className="flex items-start gap-3 rounded-xl bg-background-100/70 px-4 py-3.5">
                      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-sm font-bold text-accent-700">
                        A
                      </span>
                      <p className="text-sm leading-7 text-foreground-700">{item.a}</p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}